import {
    TextField,
    Button,
    IconButton,
    styled,
    Grid,
    List,
    ListItem,
    InputAdornment,
    Typography,
} from '@material-ui/core';
import {
    Close as RemoveIcon,
} from '@material-ui/icons';
import { brand } from '../../theme';

/** Small "x" button that lives at the end of a TextField. Used by both
 *  EditTasterItem and EditBeerItem — kept in this file because tasters are
 *  the original consumer; beer-fields imports it from here. */
export const RemoveButtonAdornment = styled(p =>
    <InputAdornment position="end">
        <IconButton
            size="small"
            onClick={p?.onRemove}
            aria-label="remove"
        >
            <RemoveIcon fontSize="small" />
        </IconButton>
    </InputAdornment>
)({
    '& .MuiSvgIcon-root': {
        fontSize: 16,
        color: brand.textSec,
    },
});

export const EditTastersList = styled(p =>
    <List {...p} />
)({
    paddingTop: 0
});

export const EditTasterItem = styled(({ className, onRemove, id, ...p }) =>
    <ListItem disableGutters dense className={className}>
        <TextField
            id={id}
            variant="outlined"
            margin="normal"
            name={p?.email}
            value={p?.email}
            fullWidth
            placeholder="Taster Email"
            autoComplete="off"
            InputProps={{
                endAdornment: (
                    <RemoveButtonAdornment onRemove={onRemove} />
                )
            }}
            {...p}
        />
    </ListItem>
)({
    paddingTop: 0
});

/** Alternative two-line layout used by Account-style edits where the user
 *  has both an email and a display name. Kept alongside the simpler
 *  EditTasterItem since it's the same conceptual entity. */
export const EditTasterItem2 = styled(({ className, onRemove, id, info, ...p }) =>
    <ListItem dense className={className} key={p?.key}>
        <Grid container direction='column'>
            <Grid item container direction='row' justifyContent='space-between' alignItems='center'>
                <Grid item>
                    <Typography variant='h6'>Taster</Typography>
                </Grid>
                <Grid item>
                    <IconButton onClick={onRemove}>
                        <RemoveIcon />
                    </IconButton>
                </Grid>
            </Grid>
            <Grid item>
                <TextField
                    id={id}
                    variant="outlined"
                    margin="normal"
                    name={info?.email}
                    value={info?.email}
                    fullWidth
                    label="Email"
                    autoComplete="off"
                    autoFocus={true}
                    onChange={p?.onChangeEmail}
                />
            </Grid>
            <Grid item>
                <TextField
                    id={id}
                    variant="outlined"
                    margin="normal"
                    name={info?.displayName}
                    value={info?.displayName}
                    fullWidth
                    label="Display Name"
                    autoComplete="off"
                    onChange={p?.onChangeDisplayName}
                />
            </Grid>
        </Grid>
    </ListItem>
)(({ theme }) => ({
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
}));

export const AddTasterButton = styled(p =>
    <Button variant="outlined" {...p} color="primary">Add Taster</Button>
)(({ theme }) => ({
    width: '100%',
    height: 46,
    borderRadius: 10,
    borderWidth: 1.5,
    fontSize: 13,
    fontWeight: 800,
    letterSpacing: 0.8,
    textTransform: 'uppercase',
    marginTop: theme.spacing(0.5),
    '&:hover': {
        borderWidth: 1.5,
    },
}));
